import { Icon, IconButton, useDisclosure } from '@chakra-ui/react';
import { AppHelpIcon } from '@monetize/ui/icons';
import { MdSearch } from 'react-icons/md';
import { ADMIN_ROLES } from '../../constants/roles';
import { useAuth } from '../../services/auth0';
import { MButton, MFlex, MText } from '../Monetize';
import { MTooltip } from '../Monetize';
import { AppDocsModal } from './AppDocsModal';

interface AppHelpSearchProps {
  isOverlay: boolean;
}

export const AppHelpSearch = ({ isOverlay }: AppHelpSearchProps) => {
  const { currentTenantUserHasRole } = useAuth();
  const { onOpen, onClose, open: isOpen } = useDisclosure();

  const isAdmin = currentTenantUserHasRole(ADMIN_ROLES);

  return (
    <MFlex
      py={1}
      px={isOverlay ? 0 : 4}
      justifyContent={isOverlay ? 'center' : 'flex-start'}
    >
      <MTooltip label={!isOverlay ? '' : 'Search Docs'}>
        {isOverlay ? (
          <IconButton
            aria-label="Search Docs"
            variant="icon"
            onClick={() => onOpen()}
            w={8}
            h={8}
            minW={8}
            borderRadius="md"
            _focusVisible={{
              outline: 'none',
              boxShadow: 'focus',
            }}
          >
            <Icon width={5} height={5} color="tGray.darkPurple" asChild>
              <AppHelpIcon />
            </Icon>
          </IconButton>
        ) : (
          <MButton
            variant="bare"
            display="flex"
            justifyContent="start"
            // Not the `border` shorthand: it sorts after the recipe's
            // `borderColor` and resets the color to currentColor.
            borderWidth="1px"
            borderStyle="solid"
            borderColor="tGray.lightPurple"
            borderRadius="md"
            textAlign="left"
            w="100%"
            p={1}
            fontWeight="normal"
            onClick={() => onOpen()}
            _focusVisible={{
              outline: 'none',
              boxShadow: 'focus',
              borderColor: 'tPurple.dark',
            }}
          >
            <Icon w="5" h="5" color="tGray.darkPurple" asChild>
              <MdSearch />
            </Icon>
            <MText ml={2} opacity={0.8}>
              Search Docs
            </MText>
          </MButton>
        )}
      </MTooltip>

      <AppDocsModal isAdmin={isAdmin} isOpen={isOpen} onClose={onClose} />
    </MFlex>
  );
};
